import React from 'react';
import { fileNameOnly, scorePercentForTurn, sourceDocKey } from '../answersService';

export const isSourceSelected = (selected, candidate) => {
  if (!selected || !candidate) return false;
  const selectedKey = sourceDocKey(selected);
  const candidateKey = sourceDocKey(candidate);
  if (selectedKey && candidateKey) return selectedKey === candidateKey;
  return (
    selected.serff_id === candidate.serff_id
    && selected.file_name === candidate.file_name
    && selected.page_start === candidate.page_start
  );
};

const AnswersEvidenceTray = ({
  className = '',
  onSelectSource,
  references,
  selectedSource,
  turn,
  updateTurn,
}) => {
  if (!references?.length) return null;

  const expanded = Boolean(turn.referencesExpanded);

  return (
    <section className={`answers-references-card ${className}`.trim()}>
      <button
        type="button"
        className="answers-references-header"
        aria-expanded={expanded}
        onClick={() => updateTurn(turn.id, (t) => ({ ...t, referencesExpanded: !t.referencesExpanded }))}
      >
        {references.length} Reference{references.length === 1 ? '' : 's'}
      </button>
      <div
        className={`answers-references-body${expanded ? ' is-expanded' : ''}`}
        aria-hidden={!expanded}
      >
        <div className="answers-references-body-inner">
          <div className="answers-reference-grid">
            {references.map((src, sidx) => (
              <button
                type="button"
                key={`${sourceDocKey(src) || src.serff_id}-${sidx}`}
                className={`answers-reference-card ${isSourceSelected(selectedSource, src) ? 'is-selected' : ''}`}
                onClick={() => onSelectSource(src)}
              >
                <span className="answers-reference-score">
                  {scorePercentForTurn(src) != null ? `${scorePercentForTurn(src)}%` : '-'}
                </span>
                <span className="answers-reference-content">
                  <strong>{src.serff_id || 'Source'}</strong>
                  {src.submitted_date && (
                    <small>
                      {new Date(src.submitted_date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
                    </small>
                  )}
                  <span>{src.product_name || src.file_name || 'Source document'}</span>
                  {src.file_name && fileNameOnly(src.file_name) !== src.product_name && (
                    <small>{fileNameOnly(src.file_name)}</small>
                  )}
                  <small>Pages {src.page_start}-{src.page_end}</small>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnswersEvidenceTray;
